import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL } from "../lib/assets";

const links = [
  { to: "/", label: "Home" },
  { to: "/vastu", label: "Vastu Principles" },
  { to: "/about", label: "About Divya" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FBF7F0]/85 backdrop-blur-xl border-b border-[#C9A227]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full overflow-hidden border border-[#C9A227]/40 bg-[#FBF7F0]">
            <img src={LOGO_URL} alt="Tarini" className="w-full h-full object-cover scale-[1.35]" />
          </div>
          <div className="leading-tight">
            <div className="font-bodoni text-lg tracking-wide text-[#1E1A17]">Tarini</div>
            <div className="overline text-[10px] text-[#A67C00]/80">Astro Vastu Solutions</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 ${
                  isActive ? "text-[#A67C00]" : "text-[#1E1A17]/80 hover:text-[#A67C00]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/contact"
            data-testid="nav-cta-consult"
            className="inline-flex items-center gap-2 bg-[#C9A227] text-white px-5 py-2.5 rounded-sm text-sm font-medium hover:bg-[#C8683F] transition-colors"
          >
            <Phone size={14} /> Book a Consultation
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-toggle-mobile"
          className="lg:hidden text-[#A67C00] p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FBF7F0]/98 backdrop-blur-xl border-t border-[#C9A227]/15">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-base font-bodoni ${isActive ? "text-[#A67C00]" : "text-[#1E1A17]/90"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="mt-3 inline-flex items-center justify-center gap-2 bg-[#C9A227] text-white px-5 py-3 rounded-sm text-sm font-medium"
            >
              <Phone size={14} /> Book a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
